<div
  class="auth"
  style="
    background-image: url(../../../assets/images/originals/bg9.jpg);
    background-repeat: no-repeat;
    background-size: auto;
    background-position: center center;
  "
>
  <div class="row d-flex justify-content-center flex-row-reverse g-0">
    <div
      class="d-flex justify-content-center align-items-center col-md-12 col-lg-8"
    >
      <div class="mx-auto app-login-box card p-5" style="width: 640px">
        <h4 class="mb-5 text-center">
          <img src="../../../assets/images/logo-blue.png" width="200" />
        </h4>

        <div>
          <form
            autocomplete="off"
            [formGroup]="registerForm"
            class="needs-validation reg-form"
          >
            <div class="position-relative d-flex flex-wrap form-group">
              <label for="name_Id" class="col-form-label"
                >{{ "Form.CompName" | translate }}
                <span class="text-danger">*</span></label
              >
              <div class="">
                <input
                  formControlName="name"
                  name="name"
                  id="name_Id"
                  placeholder="{{ 'Form.Placeholder.NAME' | translate }}"
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  required
                />
                <div
                  *ngIf="f.name.touched && f.name.errors"
                  style="
                    width: 100%;
                    margin-top: 0.25rem;
                    font-size: 80%;
                    color: #e02b1d;
                  "
                >
                  <div *ngIf="f.name.errors.required">
                    {{ "Form.Error.CompNameReq" | translate }}
                  </div>
                  <div *ngIf="f.name.errors?.whitespace">
                    Input cannot be only spaces.
                  </div>
                </div>
              </div>
            </div>

            <div class="position-relative d-flex flex-wrap form-group">
              <label for="contact_person_id" class="col-form-label"
                >{{ "Form.CONTACT_PERSON" | translate }}
                <span class="text-danger">*</span></label
              >
              <div class="">
                <input
                  formControlName="contactPerson"
                  name="contactPerson"
                  id="contact_person_id"
                  autocomplete="off"
                  placeholder="{{
                    'Form.Placeholder.CONTACT_PERSON' | translate
                  }}"
                  type="text"
                  class="form-control"
                  required
                />
                <div
                  *ngIf="f.contactPerson.touched && f.contactPerson.errors"
                  style="
                    width: 100%;
                    margin-top: 0.25rem;
                    font-size: 80%;
                    color: #e02b1d;
                  "
                >
                  <div *ngIf="f.contactPerson.errors.required">
                    {{ "Form.Error.CONTACT_PERSON" | translate }}
                  </div>
                  <div *ngIf="f.contactPerson.errors?.whitespace">
                    Input cannot be only spaces.
                  </div>
                </div>
              </div>
            </div>

            <div class="position-relative d-flex flex-wrap form-group">
              <label for="email_id" class="col-form-label"
                >{{ "Form.EMAIL" | translate }}
                <span class="text-danger">*</span></label
              >
              <div class="">
                <input
                  formControlName="emailId"
                  name="emailId"
                  id="email_id"
                  autocomplete="off"
                  placeholder="{{ 'Form.Placeholder.EMAIL' | translate }} "
                  type="text"
                  class="form-control"
                  required
                />
                <div
                  *ngIf="f.emailId.touched && f.emailId.errors"
                  style="
                    width: 100%;
                    margin-top: 0.25rem;
                    font-size: 80%;
                    color: #e02b1d;
                  "
                >
                  <div *ngIf="f.emailId.errors.required">
                    {{ "Form.Error.EMAIL" | translate }}
                  </div>
                  <div *ngIf="f.emailId.errors.email">
                    {{ "Form.Error.InvalidEmail" | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="position-relative d-flex flex-wrap form-group">
              <label for="password_id" class="col-form-label"
                >{{ "Form.PASSWORD" | translate }}
                <span class="text-danger">*</span></label
              >
              <div class="">
                <input
                  formControlName="password"
                  name="password"
                  autocomplete="new-password"
                  id="password_id"
                  placeholder="{{ 'Form.Placeholder.PASSWORD' | translate }}"
                  type="password"
                  class="form-control"
                  required
                />
                <div
                  *ngIf="f.password.touched && f.password.errors"
                  style="
                    width: 100%;
                    margin-top: 0.25rem;
                    font-size: 80%;
                    color: #e02b1d;
                  "
                >
                  <div *ngIf="f.password.errors.required">
                    {{ "Form.Error.PASSWORD" | translate }}
                  </div>
                  <div *ngIf="f.password.errors.minlength">
                    {{ "Form.Error.PASSWORDError" | translate }}
                  </div>
                  <div *ngIf="f.password.errors.pattern">
                    {{ "Form.Error.InavlidPass" | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="position-relative d-flex flex-wrap form-group">
              <label for="confirm_password_id" class="col-form-label"
                >{{ "Form.CONFIRM_PASSWORD" | translate }}
                <span class="text-danger">*</span></label
              >
              <div class="">
                <input
                  formControlName="confirmPassword"
                  name="confirmPassword"
                  id="confirm_password_id"
                  autocomplete="off"
                  placeholder="{{
                    'Form.Placeholder.CONFIRM_PASSWORD' | translate
                  }}"
                  type="password"
                  class="form-control"
                  required
                />
                <div
                  *ngIf="f.confirmPassword.touched && f.confirmPassword.errors"
                  style="
                    width: 100%;
                    margin-top: 0.25rem;
                    font-size: 80%;
                    color: #e02b1d;
                  "
                >
                  <div *ngIf="f.confirmPassword.errors.required">
                    {{ "Form.Error.CONFIRM_PASSWORD" | translate }}
                  </div>
                  <div *ngIf="f.confirmPassword.errors.match">
                    {{ "Form.Error.CONFIRM_PASSWORD_Error" | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="position-relative d-flex flex-wrap form-group">
              <label for="phone_id" class="col-form-label"
                >{{ "Form.PHONE" | translate }}
              </label>
              <div class="">
                <input
                  appIntlTelInput
                  autocomplete="off"
                  [options]="{
                    initialCountry: initialCountryCode,
                    preferredCountries: ['in', 'us'],
                    separateDialCode: true
                  }"
                  formControlName="phone"
                  name="phone"
                  id="phone_id"
                  class="form-control"
                />
                <div
                  *ngIf="f.phone.touched && f.phone.errors"
                  style="
                    width: 100%;
                    margin-top: 0.25rem;
                    font-size: 80%;
                    color: #e02b1d;
                  "
                >
                  <div
                    *ngIf="
                      f.phone.errors.invalidPhoneNumber ||
                      f.phone.errors.pattern
                    "
                  >
                    {{ "Form.Error.PhoneError" | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="position-relative row w-100">
              <div class="mt-4 align-items-center">
                <h5 class="mb-5">
                  {{ "Form.ALREADY_ACCOUNT" | translate }}
                  <a [routerLink]="['/login']" class="text-primary">{{
                    "Form.SIGN_IN" | translate
                  }}</a>
                </h5>
                <div class="modal-footer text-center justify-content-center">
                  <button
                    class="btn reset-btn btn-lg"
                    (click)="onReset()"
                    type="button"
                  >
                    {{ "Form.RESET" | translate }}
                  </button>
                  &nbsp;&nbsp;
                  <button
                    type="submit"
                    [disabled]="registerForm.invalid"
                    class="btn btn-primary btn-lg"
                    (click)="onSubmit('/userSubmit')"
                  >
                    {{ "Form.CREATE_ACCOUNT" | translate }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="d-none d-lg-block login-sidebar col-lg-4 px-5">
      <div class="slider-light">
        <div
          class="position-relative h-100 d-flex justify-content-center align-items-center"
        >
          <div class="slide-img-bg"></div>
          <div class="slider-content text-light">
            <h3>{{ "Form.THANK_YOU_TITLE" | translate }}</h3>
            <p>
              {{ "Form.Login.ARCHITECTURE_INFO_MESSAGE" | translate }}
            </p>
            <div>
              <ul>
                <li style="margin-bottom: 0.6rem">
                  <strong>{{ "Form.Login.POINT1HEADING" | translate }}</strong>
                  {{ "Form.Login.Point1" | translate }}
                </li>
                <li style="margin-bottom: 0.6rem">
                  <strong>{{ "Form.Login.POINT2HEADING" | translate }}</strong>
                  {{ "Form.Login.Point2" | translate }}
                </li>
                <li style="margin-bottom: 0.6rem">
                  <strong>{{ "Form.Login.POINT3HEADING" | translate }}</strong>
                  {{ "Form.Login.Point3" | translate }}
                </li>
                <li style="margin-bottom: 0.6rem">
                  <strong>{{ "Form.Login.POINT4HEADING" | translate }}</strong>
                  {{ "Form.Login.Point4" | translate }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
